import { render, staticRenderFns } from "./RsaPazienteDeviceListPage.vue?vue&type=template&id=2720b4f0"
import script from "./RsaPazienteDeviceListPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteDeviceListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports